module.exports = __webpack_public_path__ + "media/img/home/directions/list-9-817887c8acdb89c7c820014856661dd0.svg";